// import logo from "assets/images/logo.svg";
import img from "../assets/images/logo-2.png";

export const Logo = (props: any) => {
  return (
    // Insert SVG + path
    // <img {...props} src={logo} alt="logo" />
    <img style={{ height: "40px", width: "auto" }} src={img} alt="logo" />
  );
};
